import ouiBase from '@goldwasserexchange/oui';
import { useAccountOrderFieldApiByOpbFordId, useAccountOrderTransformApiByOpbFordId } from '../api';
import { formatNumber } from '../../../../../../../Components/NumberDisplay';
import { useCallback } from 'react';
import { AccountsOrder } from '../../type';
import { useLingui } from '@lingui/react';
import { McOpbLimite, translateMcOpbLimite } from './mcOpbLimite';
import { getMcGrossOpbDivider } from '../../../../securities';

export const useAccountOrderOpbFordPrice = () => {
  const opbFordDId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const response = useAccountOrderFieldApiByOpbFordId({
    opbFordDId,
    field: 'OPB_FORD.PRICE',
  });
  return response;
};

const McOpbLimiteWithPrice = [
  McOpbLimite.LIMITE,
  McOpbLimite.STOP_LIMIT,
  McOpbLimite.STOP_LOSS,
];

export const useAccountOrderTypeAndPriceText = () => {
  const opbFordDId = ouiBase.utils.dimensions.useCurrentPrimaryDimension();
  const {
    _,
  } = useLingui();
  const transformFunction = useCallback(
    (accountOrder: AccountsOrder | undefined) => {
      if (accountOrder == null) {
        return undefined;
      }
      const mcOpbLimite = accountOrder['OPB_FORD.MC_OPB_LIMITE'];
      const type = translateMcOpbLimite(_, mcOpbLimite);
      if (type == null) {
        return '';
      }
      if (!McOpbLimiteWithPrice.includes(mcOpbLimite as McOpbLimite)) {
        return type;
      }
      const divider = getMcGrossOpbDivider(accountOrder['S_TYPE.MC_GROSS_OPB']);
      const currency = accountOrder['C_CURRENCY.CODE'];
      const priceFormatter = formatNumber(divider === 100
        ? {
          format: {
            style: 'percent',
          },
          divider,
        }
        : {
          format: {
            style: 'currency',
            currency,
          },
          divider,
        });
      switch (mcOpbLimite) {
        case McOpbLimite.LIMITE:
        case McOpbLimite.STOP_LIMIT:
          return accountOrder['OPB_FORD.PRICE'] != null ? `${type} (${priceFormatter(accountOrder['OPB_FORD.PRICE'])})` : type;
        case McOpbLimite.STOP_LOSS:
          return accountOrder['OPB_FORD.TRIGGER_PRICE'] != null ? `${type} (${priceFormatter(accountOrder['OPB_FORD.TRIGGER_PRICE'])})` : type;
        default:
          return type;
      }
    },
    [_],
  );
  const response = useAccountOrderTransformApiByOpbFordId({
    opbFordDId,
    transformFunction,
  });
  return response;
};
